"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var top_block_view_1 = tslib_1.__importDefault(require("./top-block.view"));
var TopBlock = /** @class */ (function () {
    function TopBlock(dependencies) {
        this.isHidden = false;
        this._initUI(this._getElementsNodes(dependencies));
    }
    TopBlock.prototype._initUI = function (elementNodes) {
        var config = {
            elements: elementNodes,
        };
        this.view = new TopBlock.View(config);
    };
    TopBlock.prototype._getElementsNodes = function (dependencies) {
        var title = dependencies.title, liveIndicator = dependencies.liveIndicator;
        return {
            title: title.node,
            liveIndicator: liveIndicator.node,
        };
    };
    Object.defineProperty(TopBlock.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    TopBlock.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    TopBlock.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    TopBlock.prototype.showContent = function () {
        this.view.showContent();
    };
    TopBlock.prototype.hideContent = function () {
        this.view.hideContent();
    };
    TopBlock.prototype.destroy = function () {
        this.view.destroy();
        this.view = null;
    };
    TopBlock.moduleName = 'topBlock';
    TopBlock.View = top_block_view_1.default;
    TopBlock.dependencies = ['title', 'liveIndicator'];
    return TopBlock;
}());
exports.default = TopBlock;
//# sourceMappingURL=top-block.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/top-block/top-block.js
// module id = 133
// module chunks = 0